import { Component, Input, OnInit } from '@angular/core';
import { DestroyBase } from '../../../../../components/common/ng-destroy-base';
import { LocalizationNavigationService } from '../../../services/localization-navigation-service';

/**
 * Localization Form List component
 */
@Component({
  selector: 'localization-form-host',
  templateUrl: './localization-form-host.component.html',
  styleUrls: ['./localization-form-host.component.css']
})
export class LocalizationFormHostComponent extends DestroyBase implements OnInit {

  /**
  * Report template
  */
  @Input() reportTemplate: any;

  /**
 * Selected grid item
 */
  @Input() selectedItem: any;

  /**
   * Report designer language id
   */
  @Input() reportDesignerLanguageId: any;

  /**
   * The widget
   */
  widget: any[];

  /**
   *
   * Constructor
   * @param localizationNavigationService
   */
  constructor(private localizationNavigationService: LocalizationNavigationService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.localizationNavigationService.displayAddEditIcons(false);
  }

  /**
   * A widget was selected
   * @param widgetData
   */
  onWidgetSelection(widgetData: any) {
    this.widget = widgetData;
  }
}
